import { render, staticRenderFns } from "./CoTwoAccomodationForm.vue?vue&type=template&id=2fb2a126&scoped=true&"
import script from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoAccomodationForm.vue?vue&type=script&lang=js&"
import style0 from "./CoTwoAccomodationForm.vue?vue&type=style&index=0&id=2fb2a126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2a126",
  null
  
)

export default component.exports